import Clarity from '@microsoft/clarity';
import envConfig from 'configs/envConfig';

const projectId = envConfig('microsoftClarityProjectId');

export const enableClarity =
  envConfig('env') === 'prod' ||
  envConfig('env') === 'staging' ||
  envConfig('env') === 'luna-stg' ||
  envConfig('env') === 'luna' ||
  envConfig('env') === 'homiq-prod' ||
  envConfig('env') === 'homiq-stg' ||
  envConfig('env') === 'haloview-prod' ||
  envConfig('env') === 'haloview-stg' ||
  envConfig('env') === 'waiscen-prod' ||
  envConfig('env') === 'waiscen-stg' ||
  envConfig('env') === 'newaieye-prod' ||
  envConfig('env') === 'newaieye-stg' ||
  envConfig('env') === 'iv_sandbox-prod';

if (projectId && enableClarity) Clarity.init(projectId);
